export const checkingEmptyObject = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return 'NOT_EMPTY';
  }
  return 'EMPTY';
};

export const checkingObjectWithType = (obj, type) => {
  for (var key in obj) {
    if (key === type) return 'NOT_EMPTY';
  }
  return 'EMPTY';
};
